/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import ApiCalls from '../custom-classes/api-calls';
import { Container, Row, Card, CardBody, CardTitle, Col, Media, Button, Form, FormGroup, Label, Input, Alert, FormText} from 'reactstrap';
import { Link, Redirect } from "react-router-dom";

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json";
import LanguageToggle from "./selectors/language-selector";
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import SidebarLanding from './navbar/sidebar-landing';
import NavbarLanding from './navbar/navbar-landing';
import FormRegistration from './forms/form-subscription-registration';
import FormSubscriptionCalculation from './forms/form-subscription-calculation';
import FormSubscriptionProfileRegister from './forms/form-subscription-profile-register';
import FormSubscriptionDownload from './forms/form-subscription-download';

// Component for subscriptions
class SubscriptionSteps extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });
        this.props.addTranslation(global);

        this.state = {
            mobile: false,
            didMount: false,
            successfulRegistration: false,
            successfulSubscription: false,
            goToDownload: false,
            cameFromRegister: false
        };

        this.setRegistrationStatus = this.setRegistrationStatus.bind(this);
        this.setCalculationStatus = this.setCalculationStatus.bind(this);
        this.setSubscriptionStatus = this.setSubscriptionStatus.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.setState({didMount: true});
    }

    /**
     * To evaluate when the screen size changed
     */
    resize() {
        this.setState({mobile: window.screen.width <= 1024});
    }

    /**
     * Update the status of the registration
     * @param stateRegistrationData
     */
    setRegistrationStatus(stateRegistrationData)
    {
        this.setState({successfulRegistration: stateRegistrationData.successfulTransaction, cameFromRegister: true});
    }
    
    setCalculationStatus(stateCalculationData)
    {
        this.setState({successfulSubscription: stateCalculationData.userSubscribed, subscriptionId: stateCalculationData.subscriptionId});
    }

    setSubscriptionStatus(stateSubscriptionStatus)
    {
        console.log(stateSubscriptionStatus);
        this.setState({"goToDownload": stateSubscriptionStatus.goToDownload},()=>{
            console.log("This state", this.state);
        });
        this.setState({"goToDashboard": stateSubscriptionStatus.goToDashboard});
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        if (this.state.isLoggedIn)
            return (<Redirect to="/subscription-calculation"/>);
        else {
            let navBar = <SidebarLanding/>;
            if (this.state.mobile)
                navBar = <NavbarLanding/>;
            return (
                <div>
                    {navBar}
                    {
                        !this.state.successfulRegistration ?
                            <FormRegistration data={this.state} updateParent={this.setRegistrationStatus}/> : null
                    }
                    {
                        this.state.successfulRegistration  && !this.state.successfulSubscription ?
                        <FormSubscriptionCalculation data={this.state} updateParent={this.setCalculationStatus} /> : null
                    }
                    {
                        this.state.successfulSubscription && !this.state.goToDownload && !this.state.goToDashboard ?
                            <FormSubscriptionProfileRegister data={this.state} updateParent={this.setSubscriptionStatus} /> : null
                    }
                    {
                        this.state.goToDownload ?
                            <FormSubscriptionDownload data={this.state} /> : null
                    }
                    <Footer/>
                </div>
            )
        }
    };
}

export default withLocalize(SubscriptionSteps);


// WEBPACK FOOTER //
// ./src/components/subscription-steps.js